import { render, staticRenderFns } from "./TomasRavicule.vue?vue&type=template&id=04c13e64&scoped=true"
import script from "./TomasRavicule.vue?vue&type=script&lang=js"
export * from "./TomasRavicule.vue?vue&type=script&lang=js"
import style0 from "./TomasRavicule.vue?vue&type=style&index=0&id=04c13e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c13e64",
  null
  
)

export default component.exports